import React, { useCallback, useMemo } from 'react';
import ReactDOM from 'react-dom';
import { useDropzone } from 'react-dropzone';
import { Link } from 'react-router';
import Layout from '../layouts/claire';
import { generateRandomId, getBase64, getReadableFileSizeString } from '../../helpers';
import { Animated } from 'react-animated-css';
import Menu from '../partials/menu';
import { Popover, PopoverBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import TopRightMenu from '../partials/top_right_menu';
import BlackOverlay from '../partials/black_overlay';
import moment from 'moment';
import fakeAuth from '../../fakeAuth';
import _, { slice } from 'lodash';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import LineLoader from '../partials/line_loader';
import MaskedInput from 'react-text-mask';
import request from 'superagent';
import config from '../../config';

class Password extends React.Component {
    state = {
        files: [],
        validations: {},
        menu_toggled: false,
        bootstrapped: true
    }

    // lifecycle
    componentWillMount() {
        const { params } = this.props, { id } = params;
        /*if (params.id) {

        } else {
            this.props.router.goBack();
        }*/
    }
    componentWillReceiveProps = nextProps => {
    }
    componentWillUnmount = () => {
    }
    //    

    doSave = () => {
        const { staff } = this.state;
        const { microTransac } = this.state;
        if (!microTransac) {
            this.setState({
                microTransac: true,
                invalid: false,
                error: null
            }, () => {

                // Call API
                request.patch(`${config.apiEndpoint}/api/v4/membership/password`)
                    .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                    .send({ pass: this.txtNewPassword.value, old: this.txtCurrentPassword.value })
                    .then((data) => {

                        const { router } = this.props;
                        fakeAuth.signout(() => {
                            /*try { this.props.form_actions?.logout && this.props.form_actions.logout(); } catch (e) {
                                console.error({ e });
                            }*/
                            setTimeout(() => {
                                router.push('/login');
                            }, 800);
                            
                        });

                    }, ({ response }) => {
                        const { body } = response, { error } = body;                        
                        this.setState({ microTransac: false, error });
                        //this.props.setDeveloperMessage && this.props.setDeveloperMessage(error);
                    });
            });
        }
    }
    validate = (e) => {
        e && e.preventDefault && e.preventDefault();
        this.setState({ validations: {} }, () => {
            const { validations, staff } = this.state;

            if (!this.txtCurrentPassword.value) {
                validations.txtCurrentPassword = 'Por favor, introduce el nombre del empleado';
                this.setState({ validations }, () => { this.txtCurrentPasswordWrapper.scrollIntoView({ behavior: 'smooth' }); });
                return;
            }
            if (!this.txtNewPassword.value) {
                validations.txtNewPassword = 'Por favor, introduce el apellido del empleado';
                this.setState({ validations }, () => { this.txtCurrentPasswordWrapper.scrollIntoView({ behavior: 'smooth' }); });
                return;
            }
            if (!this.txtRepeatPassword.value) {
                validations.txtRepeatPassword = 'Por favor, introduce el correo electrónico del empleado';
                this.setState({ validations }, () => { this.txtCurrentPasswordWrapper.scrollIntoView({ behavior: 'smooth' }); });
                return;
            }
            if (this.txtRepeatPassword.value !== this.txtNewPassword.value) {
                validations.txtRepeatPassword = 'Las contraseñas no coinciden';
                this.setState({ validations }, () => { this.txtCurrentPasswordWrapper.scrollIntoView({ behavior: 'smooth' }); });
                return;
            }


            this.setState({ confirm: true });
        });
    }


    renderHeader = () => {
        return <div className="d-flex">
            <div className="w-100 d-flex ">
                <i className="icon-lb_user white font-40 align-self-center" />
                <span className="white ms-2 font-20 poppins align-self-center">Contraseña</span>
                <button onClick={() => this.props.router && this.props.router.goBack()} type="button" className="btn btn-lg btn-blue white ms-3 align-self-center" >
                    <i className="icon-corner-down-left white font-12" />
                </button>
            </div>
            <div className="w-75">
                <TopRightMenu {...this.props} />
            </div>
        </div>
    }
    renderBasic = () => {
        const { validations, staff, timezones, shifts } = this.state, { countries } = this.props;

        return <section className="mt-4">
            <h4 className="white poppins">Cambio de Contraseña</h4>
            <hr />
            <div className="w3-container">

                {/* Rest */}

                <div className="d-flex flex-column w3-content" ref={input => this.txtCurrentPasswordWrapper = input}>
                    {/* Current password  */}
                    <div className="w-100 mt-4">
                        <label className="white poppins font-12">Contraseña actual <i className="blue">*</i></label>
                        <div id="txtCurrentPassword" className={`black-input ${validations.txtCurrentPassword ? 'error-input' : ''} d-flex mt-2`}>
                            <i className="fas fa-lock font-16 white align-self-center ps-3" />
                            <input className="w-100 p-3 white" type="password" name="old" placeholder="Contraseña actual" ref={(input) => this.txtCurrentPassword = input} />
                        </div>
                        <Popover placement="right" isOpen={validations.txtCurrentPassword ? true : false} target={`txtCurrentPassword`} toggle={() => {
                            const { validations } = this.state;
                            validations.txtCurrentPassword = !validations.txtCurrentPassword;
                            this.setState({ validations });
                        }} className="bg-gray-2">
                            <PopoverBody className="d-flex flex-row justify-content-center">
                                <i className="fas fa-times red font-8 align-self-center" />
                                <span className="white font-8 poppins align-self-center ms-3" style={{ maxWidth: 100 }}>{validations.txtCurrentPassword}</span>
                            </PopoverBody>
                        </Popover>
                    </div>
                    <div className="px-1" />
                    {/* New */}
                    <div className="w-100 mt-4">
                        <label className="white poppins font-12">Nueva contraseña <i className="blue">*</i></label>
                        <div id="txtNewPassword" className={`black-input ${validations.txtNewPassword ? 'error-input' : ''} d-flex mt-2`}>
                            <i className="fas fa-lock font-16 white align-self-center ps-3" />
                            <input className="w-100 p-3 white" type="password" name="new" placeholder="Nueva contraseña" ref={(input) => this.txtNewPassword = input} />
                        </div>
                        <Popover placement="right" isOpen={validations.txtNewPassword ? true : false} target={`txtNewPassword`} toggle={() => {
                            const { validations } = this.state;
                            validations.txtNewPassword = !validations.txtNewPassword;
                            this.setState({ validations });
                        }} className="bg-gray-2">
                            <PopoverBody className="d-flex flex-row justify-content-center">
                                <i className="fas fa-times red font-8 align-self-center" />
                                <span className="white font-8 poppins align-self-center ms-3" style={{ maxWidth: 100 }}>{validations.txtNewPassword}</span>
                            </PopoverBody>
                        </Popover>
                    </div>
                    <div className="px-1" />
                    {/* Validate */}
                    <div className="w-100 mt-4">
                        <label className="white poppins font-12">Repetir contraseña <i className="blue">*</i></label>
                        <div id="txtRepeatPassword" className={`black-input ${validations.txtRepeatPassword ? 'error-input' : ''} d-flex mt-2`}>
                            <i className="fas fa-lock font-16 white align-self-center ps-3" />
                            <input className="w-100 p-3 white" type="password" name="repeat" placeholder="Repetir contraseña" ref={(input) => this.txtRepeatPassword = input} />
                        </div>
                        <Popover placement="right" isOpen={validations.txtRepeatPassword ? true : false} target={`txtRepeatPassword`} toggle={() => {
                            const { validations } = this.state;
                            validations.txtRepeatPassword = !validations.txtRepeatPassword;
                            this.setState({ validations });
                        }} className="bg-gray-2">
                            <PopoverBody className="d-flex flex-row justify-content-center">
                                <i className="fas fa-times red font-8 align-self-center" />
                                <span className="white font-8 poppins align-self-center ms-3" style={{ maxWidth: 100 }}>{validations.txtRepeatPassword}</span>
                            </PopoverBody>
                        </Popover>
                    </div>
                </div>


            </div>
        </section>
    }

    renderCommon = () => {

        return (
            <div>
                {this.renderHeader()}
                <section>
                    {this.state.bootstrapped && <Animated animationInDuration={200} animationOutDuration={200} isVisible={this.state.toggle} animationOut="fadeOutRight" animationIn="fadeInRight" className="mt-4">
                        {this.renderBasic()}

                        {/* Buttons */}
                        <div className="d-flex justify-content-center mt-4">
                            <button onClick={() => this.props.router && this.props.router.goBack()} type="button" className="btn btn-lg btn-blue white align-self-center" >
                                <i className="icon-corner-down-left white font-12" />
                            </button>
                            <button onClick={this.validate} type="button" className="btn btn-lg btn-blue white ms-3 align-self-center" >
                                <i className="far fa-save white font-12" />
                            </button>
                        </div>
                    </Animated>}
                </section>
                <div style={{ height: 100 }} />
            </div>
        )
    }
    render() {
        const form = this.props.form_actions;
        return (
            <Layout router={this.props.router} nbs="home" title="legendbeds" form={this.props.form} form_actions={this.props.form_actions}>
                <section>

                    {this.state.microTransac && <LineLoader />}

                    {/* DESKTOP */}
                    <div className="w3-container w3-hide-small " style={{ marginLeft: 100 }}>
                        <div style={{ height: 50 }} />
                        {this.renderCommon()}
                    </div>
                    {/* MOBILE */}
                    {/*<div className="w3-container w3-hide-medium w3-hide-large">
                        <div style={{ height: 65 }} />
                        {this.renderCommon()}
        </div>*/}

                    <Menu {...this.state} {...this.props} />

                    {/* Confirm */}
                    <Animated animateOnMount={false} animationIn='fadeIn' animationInDuration={200} animationOutDuration={200} animationOut='fadeOut' isVisible={this.state.confirm ? true : false}>
                        <BlackOverlay />
                        <div className="d-flex justify-content-center" style={{ position: 'fixed', top: 0, bottom: 0, left: 100, right: 0, zIndex: 1 }}>
                            <div className="black-input bg-gray-2 p-4 align-self-center">
                                <h3 className="white poppins text-center">Confirmar operación</h3>
                                <h6 className="blue text-center poppins">Cambio de contraseña</h6>
                                <hr className="w-50 mx-auto" />
                                <h6 className="line1 white text-center poppins">¿Está seguro que desea guardar los cambios?<br />(Se le solicitará ingresar al sistema nuevamente)</h6>
                                <div className="d-flex justify-content-center mt-4">
                                    <button onClick={() => this.setState({ confirm: false })} type="button" className="btn btn-lg btn-gray-2 white ms-3 align-self-center" >
                                        <i className="fas fa-times white font-12" />
                                    </button>
                                    <button onClick={this.doSave} type="button" className="btn btn-lg btn-blue white ms-3 align-self-center" >
                                        <i className="fas fa-check white font-12" />
                                    </button>
                                </div>
                                {this.state.error?.message && <div className="bg-danger mt-2 p-2 white rounded">{this.state.error.message}</div>}
                            </div>
                        </div>
                    </Animated>

                </section>
            </Layout>
        )
    }
}

export default Password;
